import React from 'react';
import './App.css';
import BodyContainer from "./BodyContainer";
import {Typography} from "@material-ui/core";
import FavoriteIcon from '@material-ui/icons/Favorite';
import Link from "@material-ui/core/Link";

function App() {

    return (
        <div className="App">
            <BodyContainer/>
            <div style={{height: 36, width: '100%', background: '#EEE', display: 'flex'}}>
                <div style={{margin: 'auto', display: 'flex', alignItems: 'center'}}>
                    <Typography variant="caption">Made with</Typography>
                    <FavoriteIcon fontSize="small" style={{ color: "#F06292", marginRight: '4px', marginLeft: '4px' }}/>
                    <Typography variant="caption">by <Link href="https://github.com/wasim-abuzaher"
                                                           target="_blank"
                                                           rel="noreferrer">Wasim</Link></Typography>
                </div>
            </div>
        </div>
    );
}

export default App;
